import * as PatientApis from '../apis/patient';
import * as ActionTypes from '../constants/actions';
import _ from 'lodash';
import * as UserApis from '../apis/user'



export function getUserContactList(data, callback) {
	return async (dispatch) => {
 	  const response = await UserApis.getRegisteredUserContactList(data);
	  if (response.status === "200") {
		const responseData = {
		  totalCount: response.totalCount,
		  contacts: response.contacts
		}
		// const myContacts = Object.keys(response.contacts || {}).reduce((acc, key) => {
		//   const newKey = response.contacts[key]?.mobileNumber || key;
		//   const contact = response.contacts[key];
		//   if (contact?.mobileNumber == '911234567890') {
		// 	contact.firstName = 'kure'
		// 	contact.lastName = ''
		// 	contact.nickname = 'kure'
		//   }
		//   acc[newKey] = contact;
		//   return acc;
		// }, {});
		const myContacts = response.contacts.map(contact => {
			return {
				'firstName': contact.firstName, 
				'lastName': contact.lastName,
				'mobileNumber': contact.mobileNumber,
				'profilePictureUrl': contact.profilePictureUrl,
				'userId': contact.userId,
				'roomID': contact.roomID,
				"discipline": contact.discipline
			} 
			
		})

		let smallContactList = []
		for(let i in myContacts){
			if(i < 50){
				smallContactList.push(myContacts[i])
			} else{
				break
			}

		}


		dispatch(appendMyContactList(smallContactList));
		// if (callback) {
		//   return callback(responseData);
		// }
	  }
	};
  }


  export function appendMyContactList(contact) {
	return {
		type : ActionTypes.CONTACTS.APPEND_MY_CONTACT_LIST,
        contact
	};
}
